export default __webpack_public_path__ + "pgnv-assets/cd9b79ead5cecf3afb7dd9fa881f9d2d.png";